import { useMemo } from 'react'

import { useModal } from 'primsell-shared-layer/features'
import { ErrorModal } from 'features'

import { ModalVariantE } from './modal.enums'
import { ChangeNetworkModal, ImagePreviewModal } from 'primsell-shared-layer/components'
import { ModalVariantCommonE } from 'primsell-shared-layer/types'

const ModalController = () => {
  const { activeModal } = useModal()

  const mainModal = useMemo(() => {
    switch (activeModal) {
      case ModalVariantCommonE.IMAGE_PREVIEW:
        return <ImagePreviewModal />
      case ModalVariantE.ERROR_MODAL:
        return <ErrorModal />
      case ModalVariantCommonE.CHANGE_NETWORK_MODAL:
        return <ChangeNetworkModal />
      case 'closed':
        return null
      default:
        return null
    }
  }, [activeModal])

  return <>{mainModal}</>
}

export { ModalController }
